import { useSelector } from 'react-redux';

export const USER_TYPE_PERMISSIONS = {
  A: [ // Admin
    'tax:view',
    'tax:create',
    'tax:prepare',
    'tax:approve',
  ],
  E: [ // Employee
    'tax:view',
    'tax:create',
    'tax:prepare',
  ],
};

export function getPermissionsForUserType(userTypeCode) {
  return USER_TYPE_PERMISSIONS[userTypeCode] || [];
}

export function usePermission(permission) {
  const permissions = useSelector((s) => s.auth?.user?.permissions) || [];
  return permissions.includes(permission);
}